(function() {
    'use strict';

    angular
        .module('app')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['authenticator', '$scope', '$state', '$rootScope', '$stateParams', '$http'];

    function LoginController(authenticator, $scope, $state, $rootScope, $stateParams, $http){
        var vm = this;
        vm.email = '';
        vm.password = '';
        vm.checkEmail = checkEmail;
        vm.login = login;
        vm.goToCheckout = goToCheckout;
        vm.close = close;
        vm.error_message = false;
        vm.remember_me = false;
        vm.$onInit = init;
        vm.loginOrSignInWithFacebook = loginOrSignInWithFacebook;
        vm.logoutFacebook = logoutFacebook;
        function init() {
            window.document.title = $stateParams.language == 'da' ? "Log ind - Be My Concert" : "Log in - Be My Concert";

            $rootScope.dark_text_header = true;
            $rootScope.separate_page  = true;
            vm.concert = $stateParams.concert;
            $scope.$on('$destroy', function () {
                $rootScope.dark_text_header = false;
                $rootScope.separate_page  = false;
            })
            vm.fromConcert = (vm.concert && vm.concert != '') || $stateParams.backToStateName == 'buy_tickets' || $stateParams.backToStateName == 'checkout';
            vm.fromGiftcard = $stateParams.backToStateName == 'buy_gift_card';
            vm.fromBuyPage = vm.fromConcert || vm.fromGiftcard;
        }

        function goToCheckout() {
            if(vm.email) {
                $http.get('api/users/check_email/' + vm.email.replace('+', '%2B')).then(function(response){
                    if(!response.data.email_already_exists || (response.data.email_already_exists && response.data.is_light)) {
                        $http.post('api/users/light/', {email: vm.email}).then(function(response){
                            authenticator.loginLight(vm.email).then(function(response){
                                if(vm.fromBuyPage) {
                                    if(vm.concert && vm.concert != '') {
                                        $state.go('buy_tickets', {concert_slug: $stateParams.concert, source_page: $stateParams.source_page});
                                    } else {
                                        $state.go($stateParams.backToStateName, $stateParams.backToStateParams)
                                    }
                                }
                            });
                        });
                    } else {
                        vm.email_already_exists = true;
                    }
                });
            } else {
                vm.loginFormMobile.$setSubmitted();
                vm.showEmailNeeded = true;
            }
        }

        function checkEmail() {
            $http.get('api/users/check_email/' + vm.email.replace('+', '%2B')).then(function(response){
                var params = angular.copy($state.params);
                if($stateParams.concert && $stateParams.concert != ''){
                    params.concert = $stateParams.concert;
                }
                params.user_email = vm.email;
                if(response.data.email_already_exists && !response.data.is_light) {
                    return $state.go('login_return', params);
                } else {
                    return $state.go('sign_up', params);
                }
            });
        }

        function login() { //Login if password and email match, otherwise return error and check the login-status again
            authenticator.login(vm.email, vm.password, vm.remember_me)
                .then(function(response){
                    if (response === 'no_email_found') {
                        vm.email_invalid = true;
                        vm.error_message = 'Email and password do not match';
                    }
                    else if (response) {
                        close().then(reload);
                    }
                    else {
                        vm.password_invalid = true;
                        vm.error_message = 'Email and password do not match';
                    }
                });
        }

        function close(){
            if($stateParams.backToStateName){
                console.log(1, $stateParams.backToStateName, $stateParams.backToStateParams);
                // if the backToStateName has been set in the authResolve in routing
                return $state.go($stateParams.backToStateName, $stateParams.backToStateParams)
            } else if($rootScope.previousState && typeof $rootScope.previousState.name == 'string'){
                console.log(2);
                // if the previous state has been set in $transitions hook
                return $state.go($rootScope.previousState.name, $rootScope.previousState.params);
            } else {
                console.log(3);
                return $state.go('frontpage');
            }
        }

        function reload(){
            // necessary to force Firefox to wait until the close() promise is correctly resolved before reloading
            setTimeout(function(){
                location.reload();
            },1);
        }

        function loginOrSignInWithFacebook(){
            return authenticator.loginWithFacebook()
                .then(function(response){
                    if(response && response.data && response.data.facebook_login_validated && response.data.has_user){
                        if ($stateParams.concert && $stateParams.concert != '') {
                            $state.go('buy_tickets', {concert_slug: $stateParams.concert});
                        } else {
                            if ($stateParams.backToStateName && $stateParams.backToStateName != '' && $stateParams.backToStateName != 'login') {
                                $state.go($stateParams.backToStateName, $stateParams.backToStateParams);
                            }
                            else {
                                $state.go('frontpage');
                            }
                        }
                        setTimeout(function () {
                            $rootScope.$emit('check_login_status');
                        }, 0);
                    } else if(response.data && response.data.facebook_login_validated && !response.data.has_user) {
                        $state.go('sign_up', {user_email: response.data.user_info.user_email, user_info: response.data.user_info});
                    } else {
                        vm.error_message = 'We cannot log you in with Facebook right now. Are you sure you have signed up with Facebook?';
                    }
                });
        }

        function logoutFacebook(){
            return authenticator.logoutFacebook();
        }
    }
})();
